import { useTripViewTabTargetPath } from "./useTripViewTabTargetPath";

/** Nested sidebar Trip View link opens browse landing (v1). */
export function useTripViewSidebarTargetPath(): string {
  return useTripViewTabTargetPath();
}
